module.exports = __webpack_public_path__ + "static/media/plus.10db4c25.png";